export enum FilterOperatorEnum {
    And = 'and',
    Or = 'or',
    Any = 'any',
}
